import localStorageKeys from '@/constants/local-storage-keys';

export const usePreviousSearch = (
  keysToSave = ['departureStation', 'arrivalStation', 'adults', 'children'],
) => {
  const previousSearchState = useLocalStorage(
    localStorageKeys.PREVIOUS_SEARCH,
    {},
  );

  function _filterKeys(data) {
    return keysToSave.reduce((result, key) => {
      const keyData = data[key];
      if (!keyData) return result;

      return { ...result, [key]: keyData };
    }, {});
  }

  function add(payload) {
    const payloadFiltered = _filterKeys(payload);

    previousSearchState.value = {
      ...previousSearchState.value,
      ...payloadFiltered,
    };
  }

  function get() {
    return _filterKeys(previousSearchState.value);
  }

  function clear() {
    previousSearchState.value = {};
  }

  return { data: previousSearchState, add, get, clear };
};
